// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2tG-E","signatureButtonsRight":"ModalSign_signatureButtonsRight__3iRT1"};